import type { DropdownItem, RoundCount } from "@search/api/types";
import NumberFilter from "@search/store/filters/primitive/NumberFilter";
import pluralize from "pluralize";

const defaultOption: DropdownItem = Object.freeze({
  value: -999,
  label: "Any rounds",
});

class RoundFilter extends NumberFilter {
  constructor(value: number) {
    super({
      defaultValue: defaultOption.value,
      label: "round",
      name: "rounds",
      value,
    });
  }

  options(rounds: Array<RoundCount> = []) {
    const list = rounds.map((item) => {
      const { rounds } = item;
      const label = `${rounds}${item.isPlus ? "+" : ""} ${pluralize("round", rounds, false)} (${item.count})`;

      return { label, value: rounds } as DropdownItem;
    });

    if (list.length > 0) {
      list.unshift(defaultOption);
    }

    return list;
  }
}

export default RoundFilter;
export { RoundFilter };
